import { Component } from "react";
import { connect } from "react-redux";

import { FETCH_ADMINS } from "common/actions/common";
import { ErrorView } from "common/components/error";
import { ErrorFetchingAdmins } from "common/helpers/errors";
import { Placeholder } from "common/components/placeholder";

const mapStateToProps = (state, ownProps) => ({
    isLoading: state.common.admins.loading,
    error: state.common.admins.error,
    data: state.common.admins.data
});

const mapDispatchToProps = {
    FETCH_ADMINS
};

export class AdminsList extends Component {
    componentDidMount() {
        if (this.props.data === null) {
            this.props.FETCH_ADMINS();
        }
    }
    
    render() {
        if (this.props.isLoading) {
            return (
                <div>
                    <Placeholder size="medium" />
                    <Placeholder size="long" />
                </div>
            );
        }
        
        if (this.props.error) {
            return (
                <ErrorView
                    error={new ErrorFetchingAdmins({
                        custom: true,
                        message: "Error fetching admins",
                        actions: false
                    })}
                />
            );
        }
        
        if (this.props.data && this.props.data.length) {
            return (
                <div className="admins-list">
                    {this.props.data.map(({ name, email }) => <div className="admin" key={email}>{name && `${name} at `}<a href={`mailto:${email}`}>{email}</a></div>)}
                </div>
            );
        }
        
        return null;
    }
}

export const AdminsListRedux = connect(mapStateToProps, mapDispatchToProps)(AdminsList);
